import { ServiceKey } from "@models/service";

/**
 * Which result-table layout a job renders, chosen by the job's SERVICE. A
 * service without a dedicated layout falls back to the default one.
 */
export const ResultTableVariant = {
  TechnicalManual: "technical-manual",
  Wd: "wd-mapping",
  Default: "default",
} as const;
export type ResultTableVariant =
  (typeof ResultTableVariant)[keyof typeof ResultTableVariant];

const VARIANT_BY_SERVICE: Readonly<Record<string, ResultTableVariant>> = {
  [ServiceKey.TechnicalManual]: ResultTableVariant.TechnicalManual,
  [ServiceKey.Wd]: ResultTableVariant.Wd,
};

/** Resolves a job's service key to its table variant. */
export const resolveResultTableVariant = (
  service: string | null | undefined,
): ResultTableVariant =>
  (service ? VARIANT_BY_SERVICE[service] : undefined) ??
  ResultTableVariant.Default;
